module.exports = __webpack_public_path__ + "static/media/ruhtinas-crown+logo-white-bg-gold-400x240.a7c67a53.png";